import { Route, Navigate } from "react-router-dom";

// helpers
import { APICore } from "../helpers/api/apiCore";

/**
 * Private Route forces the authorization before the route can be accessed
 * @param {*} param0
 * @returns
 */

const PrivateRoute = ({ children }) => {
  const api = new APICore();

  console.log("Checking user authentication status...");
  if (api.isUserAuthenticated() === false) {
    // not logged in so redirect to login page
    return <Navigate to="/auth/login" replace />;
  }

  // authorised so return children
  return children;
};

export default PrivateRoute;
